export const DATE_RANGE_OPTIONS = [
	{ value: "all_time", label: "All Time" },
	{ value: "past", label: "Past" },
	{ value: "upcoming", label: "Upcoming" },
] as const;

export const config = {
	defaultSortName: "employeeName",
	defaultSortDirection: "asc" as const,
	defaultPageNumber: 1,
	pageSize: 25,
	defaultDateRange: "all_time" as const,
};
